// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XoXW","colBig":"styles_colBig__YygZL","colSmall":"styles_colSmall__1ZL-u","shopifyNameWrapper":"styles_shopifyNameWrapper__2gQJp"};